
import VueScrollTo from 'vue-scrollto'
export default {
  name: 'Features',
  props: {
    features: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
      animationInAction: false,
      tabHeight: 0,
    }
  },
  computed: {
    shouldExpand() {
      return this.tabHeight > 300
    },
    parentContainer() {
      return this.$parent.$refs?.featuresSectionContainer || false
    },
  },
  watch: {
    expanded(newValue) {
      this.animationInAction = true
      setTimeout(
        () => {
          this.animationInAction = false
        },
        newValue ? 500 : 75,
      )
      if (newValue === false) {
        try {
          VueScrollTo.scrollTo(this.parentContainer, 600, {
            offset: -80,
          })
        } catch (ex) {
          this.$sentry.captureException(ex)
        }
      }
    },
  },
  updated() {
    this.setTabHeight()
  },
  mounted() {
    this.setTabHeight()
  },
  methods: {
    setTabHeight() {
      const firstTabRefScrollHeight = this.$refs?.tab?.scrollHeight || 0
      if (
        this.tabHeight <= 300 &&
        firstTabRefScrollHeight > 300 &&
        this.tabHeight !== firstTabRefScrollHeight
      ) {
        this.tabHeight = firstTabRefScrollHeight
      }
    },
  },
}
